/**
 * A wrapper for the initial response from a fetch call that funnels to
 * res.json().
 *
 * @private
 * @param {Response} res
 * @returns {Promise}
 */
function jsonResponse(res) {
  if (!res.ok) throw new Error(`${res.status}: ${res.statusText}`);

  return res.json();
}

/**
 * A light wrapper around fetch that assumes you're seeking a JSON response.
 *
 * @param {String|Request} input
 * @param {Object} init
 * @returns {Promise}
 */
export default function getJSON(input, init) {
  return fetch(input, init).then(jsonResponse);
}

/**
 * Like getJSON, but also returns when the file was last modified (from the
 * Last-Modified header S3 sends), so "last updated" reflects the data itself.
 * lastModified is null if the header is missing.
 *
 * @param {String|Request} input
 * @param {Object} init
 * @returns {Promise<{data: any, lastModified: Date|null}>}
 */
export function getJSONWithLastModified(input, init) {
  return fetch(input, init).then(res => {
    const header = res.headers.get('Last-Modified');
    const lastModified = header ? new Date(header) : null;

    return jsonResponse(res).then(data => ({
      data,
      lastModified:
        lastModified && !isNaN(lastModified.getTime()) ? lastModified : null,
    }));
  });
}
